import { useAddCartItem } from '@/features/cart/hooks'
import { NativeSelect } from '@lounge-fe/ui-kit'
import type { SelectAmountProps } from './types'
import { Money } from '@/components/Money'
import { useShopify } from '@/hooks/useShopify'
import { useTranslation } from 'react-i18next'

export const SelectAmount: React.FC<SelectAmountProps> = ({
  product,
  onSelect: parentOnSelect,
  onError,
}) => {
  // Keep track of our own recently added state to prevent cart closing.
  const addItem = useAddCartItem({ useRecentlyAdded: false })
  const { currency } = useShopify()
  const { t } = useTranslation()

  const onSelect = (variantId: string | undefined) => {
    if (variantId) {
      addItem.mutate(
        { id: Number(variantId), quantity: 1 },
        {
          onError,
          onSuccess: parentOnSelect,
        },
      )
    }
  }

  return (
    <NativeSelect
      id="select-amount"
      ariaLabel={t('product.select_amount')}
      defaultValue={t('product.select_amount')}
      className="h-auto"
      onSelect={onSelect}
      options={product.variants.map((variant) => (
        <Money
          key={`select-amount-${variant.id}`}
          data={{
            amount: (variant.price / 100).toString(),
            currencyCode: currency.active,
          }}
          as="option"
          value={variant.id.toString()}
        />
      ))}
    >
      <span className="underline">{t('product.select_amount')}</span>
    </NativeSelect>
  )
}
